import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _awaitAsyncGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator.js";
import _wrapAsyncGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }

import { generateHttpFetch } from './http-fetch.mjs';
import { CLIENT, SDK_VARIANT_HEADER, SDK_VERSION_HEADER, DEFAULT_SDK_VARIANT, DEFAULT_CLIENT_VERSION, DEFER_OPERATION_REGEX, CONTENT_TYPES, UNEXPECTED_CONTENT_TYPE_ERROR, GQL_API_ERROR, NO_DATA_OR_ERRORS_ERROR, BOUNDARY_HEADER_REGEX, RETRY_WAIT_TIME, HEADER_SEPARATOR } from './constants.mjs';
import { validateRetries, formatErrorMessage, getErrorMessage, getErrorCause, getKeyValueIfValid, combineErrors, buildCombinedDataObject, buildDataObjectByPath } from './utilities.mjs';

function createGraphQLClient(_ref) {
  var headers = _ref.headers,
      url = _ref.url,
      _ref$customFetchApi = _ref.customFetchApi,
      customFetchApi = _ref$customFetchApi === void 0 ? fetch : _ref$customFetchApi,
      _ref$retries = _ref.retries,
      retries = _ref$retries === void 0 ? 0 : _ref$retries,
      logger = _ref.logger;
  validateRetries({
    client: CLIENT,
    retries: retries
  });
  var config = {
    headers: headers,
    url: url,
    retries: retries
  };
  var clientLogger = generateClientLogger(logger);
  var httpFetch = generateHttpFetch({
    customFetchApi: customFetchApi,
    clientLogger: clientLogger,
    defaultRetryWaitTime: RETRY_WAIT_TIME
  });
  var fetchFn = generateFetch(httpFetch, config);
  var request = generateRequest(fetchFn);
  var requestStream = generateRequestStream(fetchFn);
  return {
    config: config,
    fetch: fetchFn,
    request: request,
    requestStream: requestStream
  };
}

function generateClientLogger(logger) {
  return function (logContent) {
    if (logger) {
      logger(logContent);
    }
  };
}

function processJSONResponse(_x2) {
  return _processJSONResponse.apply(this, arguments);
}

function _processJSONResponse() {
  _processJSONResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(response) {
    var _yield$response$json, errors, data, extensions;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return response.json();

          case 2:
            _yield$response$json = _context9.sent;
            errors = _yield$response$json.errors;
            data = _yield$response$json.data;
            extensions = _yield$response$json.extensions;
            return _context9.abrupt("return", _objectSpread(_objectSpread(_objectSpread({}, getKeyValueIfValid('data', data)), getKeyValueIfValid('extensions', extensions)), {}, {
              headers: response.headers
            }, errors || !data ? {
              errors: _objectSpread(_objectSpread({
                networkStatusCode: response.status,
                message: formatErrorMessage(errors ? GQL_API_ERROR : NO_DATA_OR_ERRORS_ERROR)
              }, getKeyValueIfValid('graphQLErrors', errors)), {}, {
                response: response
              })
            } : {}));

          case 7:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _processJSONResponse.apply(this, arguments);
}

function generateFetch(httpFetch, _ref2) {
  var url = _ref2.url,
      headers = _ref2.headers,
      retries = _ref2.retries;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(operation) {
      var options,
          variables,
          overrideHeaders,
          overrideUrl,
          overrideRetries,
          signal,
          body,
          flatHeaders,
          fetchParams,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              variables = options.variables, overrideHeaders = options.headers, overrideUrl = options.url, overrideRetries = options.retries, signal = options.signal;
              body = JSON.stringify({
                query: operation,
                variables: variables
              });
              validateRetries({
                client: CLIENT,
                retries: overrideRetries
              });
              flatHeaders = Object.entries(_objectSpread(_objectSpread({}, headers), overrideHeaders)).reduce(function (headers, _ref4) {
                var _ref5 = _slicedToArray(_ref4, 2),
                    key = _ref5[0],
                    value = _ref5[1];

                headers[key] = Array.isArray(value) ? value.join(', ') : value.toString();
                return headers;
              }, {});

              if (!flatHeaders[SDK_VARIANT_HEADER] && !flatHeaders[SDK_VERSION_HEADER]) {
                flatHeaders[SDK_VARIANT_HEADER] = DEFAULT_SDK_VARIANT;
                flatHeaders[SDK_VERSION_HEADER] = DEFAULT_CLIENT_VERSION;
              }

              fetchParams = [overrideUrl !== null && overrideUrl !== void 0 ? overrideUrl : url, {
                method: 'POST',
                headers: flatHeaders,
                body: body,
                signal: signal
              }];
              return _context.abrupt("return", httpFetch(fetchParams, 1, overrideRetries !== null && overrideRetries !== void 0 ? overrideRetries : retries));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function generateRequest(fetchFn) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var response,
        status,
        statusText,
        contentType,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!DEFER_OPERATION_REGEX.test(_args2.length <= 0 ? undefined : _args2[0])) {
              _context2.next = 2;
              break;
            }

            throw new Error(formatErrorMessage('This operation will result in a streamable response - use requestStream() instead.'));

          case 2:
            _context2.prev = 2;
            _context2.next = 5;
            return fetchFn.apply(void 0, _args2);

          case 5:
            response = _context2.sent;
            status = response.status, statusText = response.statusText;
            contentType = response.headers.get('content-type') || '';

            if (response.ok) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt("return", {
              errors: {
                networkStatusCode: status,
                message: formatErrorMessage(statusText),
                response: response
              }
            });

          case 10:
            if (contentType.includes(CONTENT_TYPES.json)) {
              _context2.next = 12;
              break;
            }

            return _context2.abrupt("return", {
              errors: {
                networkStatusCode: status,
                message: formatErrorMessage("".concat(UNEXPECTED_CONTENT_TYPE_ERROR, " ").concat(contentType)),
                response: response
              }
            });

          case 12:
            return _context2.abrupt("return", processJSONResponse(response));

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", {
              errors: {
                message: getErrorMessage(_context2.t0)
              }
            });

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 15]]);
  }));
}

function getStreamBodyIterator(_x) {
  return _getStreamBodyIterator.apply(this, arguments);
}

function _getStreamBodyIterator() {
  _getStreamBodyIterator = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(response) {
    var decoder, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, chunk, reader, readResult;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            decoder = new TextDecoder(); // Response body is an async iterator

            if (!response.body[Symbol.asyncIterator]) {
              _context3.next = 33;
              break;
            }

            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context3.prev = 4;
            _iterator = _asyncIterator(response.body);

          case 6:
            _context3.next = 8;
            return _awaitAsyncGenerator(_iterator.next());

          case 8:
            if (!(_iteratorAbruptCompletion = !(_step = _context3.sent).done)) {
              _context3.next = 15;
              break;
            }

            chunk = _step.value;
            _context3.next = 12;
            return decoder.decode(chunk);

          case 12:
            _iteratorAbruptCompletion = false;
            _context3.next = 6;
            break;

          case 15:
            _context3.next = 21;
            break;

          case 17:
            _context3.prev = 17;
            _context3.t0 = _context3["catch"](4);
            _didIteratorError = true;
            _iteratorError = _context3.t0;

          case 21:
            _context3.prev = 21;
            _context3.prev = 22;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context3.next = 26;
              break;
            }

            _context3.next = 26;
            return _awaitAsyncGenerator(_iterator.return());

          case 26:
            _context3.prev = 26;

            if (!_didIteratorError) {
              _context3.next = 29;
              break;
            }

            throw _iteratorError;

          case 29:
            return _context3.finish(26);

          case 30:
            return _context3.finish(21);

          case 31:
            _context3.next = 45;
            break;

          case 33:
            reader = response.body.getReader();
            _context3.prev = 34;

          case 35:
            _context3.next = 37;
            return _awaitAsyncGenerator(reader.read());

          case 37:
            if ((readResult = _context3.sent).done) {
              _context3.next = 42;
              break;
            }

            _context3.next = 40;
            return decoder.decode(readResult.value);

          case 40:
            _context3.next = 35;
            break;

          case 42:
            _context3.prev = 42;
            reader.cancel();
            return _context3.finish(42);

          case 45:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[4, 17, 21, 31], [22,, 26, 30], [34,, 42, 45]]);
  }));
  return _getStreamBodyIterator.apply(this, arguments);
}

function readStreamChunk(streamBodyIterator, boundary) {
  return _defineProperty({}, Symbol.asyncIterator, function () {
    return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var buffer, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, textChunk, lastBoundaryIndex, fullResponses, chunkBodies;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              buffer = '';
              _iteratorAbruptCompletion2 = false;
              _didIteratorError2 = false;
              _context4.prev = 4;
              _iterator2 = _asyncIterator(streamBodyIterator);

            case 6:
              _context4.next = 8;
              return _awaitAsyncGenerator(_iterator2.next());

            case 8:
              if (!(_iteratorAbruptCompletion2 = !(_step2 = _context4.sent).done)) {
                _context4.next = 23;
                break;
              }

              textChunk = _step2.value;
              buffer += textChunk;

              if (!(buffer.indexOf(boundary) > -1)) {
                _context4.next = 20;
                break;
              }

              lastBoundaryIndex = buffer.lastIndexOf(boundary);
              fullResponses = buffer.slice(0, lastBoundaryIndex);
              chunkBodies = fullResponses.split(boundary).filter(function (chunk) {
                return chunk.trim().length > 0;
              }).map(function (chunk) {
                var body = chunk.slice(chunk.indexOf(HEADER_SEPARATOR) + HEADER_SEPARATOR.length).trim();
                return body;
              });

              if (!(chunkBodies.length > 0)) {
                _context4.next = 18;
                break;
              }

              _context4.next = 18;
              return chunkBodies;

            case 18:
              buffer = buffer.slice(lastBoundaryIndex + boundary.length);

              if (buffer.trim() === "--") {
                buffer = '';
              }

            case 20:
              _iteratorAbruptCompletion2 = false;
              _context4.next = 6;
              break;

            case 23:
              _context4.next = 29;
              break;

            case 25:
              _context4.prev = 25;
              _context4.t0 = _context4["catch"](4);
              _didIteratorError2 = true;
              _iteratorError2 = _context4.t0;

            case 29:
              _context4.prev = 29;
              _context4.prev = 30;

              if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                _context4.next = 34;
                break;
              }

              _context4.next = 34;
              return _awaitAsyncGenerator(_iterator2.return());

            case 34:
              _context4.prev = 34;

              if (!_didIteratorError2) {
                _context4.next = 37;
                break;
              }

              throw _iteratorError2;

            case 37:
              return _context4.finish(34);

            case 38:
              return _context4.finish(29);

            case 39:
              _context4.next = 44;
              break;

            case 41:
              _context4.prev = 41;
              _context4.t1 = _context4["catch"](0);
              throw new Error("Error occured while processing stream payload - ".concat(getErrorMessage(_context4.t1)));

            case 44:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 41], [4, 25, 29, 39], [30,, 34, 38]]);
    }))();
  });
}

function createJsonResponseAsyncIterator(response) {
  return _defineProperty({}, Symbol.asyncIterator, function () {
    return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var processedResponse;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _awaitAsyncGenerator(processJSONResponse(response));

            case 2:
              processedResponse = _context5.sent;
              _context5.next = 5;
              return _objectSpread(_objectSpread({}, processedResponse), {}, {
                hasNext: false
              });

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  });
}

function getResponseDataFromChunkBodies(chunkBodies) {
  return chunkBodies.map(function (value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      throw new Error("Error in parsing multipart response - ".concat(getErrorMessage(error)));
    }
  }).map(function (payload) {
    var data = payload.data,
        incremental = payload.incremental,
        hasNext = payload.hasNext,
        extensions = payload.extensions,
        errors = payload.errors; // initial data chunk

    if (!incremental) {
      return _objectSpread(_objectSpread(_objectSpread({
        data: data || {}
      }, getKeyValueIfValid('errors', errors)), getKeyValueIfValid('extensions', extensions)), {}, {
        hasNext: hasNext
      });
    } // subsequent data chunks


    var incrementalArray = incremental.map(function (_ref9) {
      var data = _ref9.data,
          path = _ref9.path,
          errors = _ref9.errors;
      return _objectSpread({
        data: data && path ? buildDataObjectByPath(path, data) : {}
      }, getKeyValueIfValid('errors', errors));
    });
    return _objectSpread(_objectSpread({
      data: incrementalArray.length === 1 ? incrementalArray[0].data : buildCombinedDataObject(_toConsumableArray(incrementalArray.map(function (_ref10) {
        var data = _ref10.data;
        return data;
      })))
    }, getKeyValueIfValid('errors', combineErrors(incrementalArray))), {}, {
      hasNext: hasNext
    });
  });
}

function validateResponseData(responseErrors, combinedData) {
  if (responseErrors.length > 0) {
    throw new Error(GQL_API_ERROR, {
      cause: {
        graphQLErrors: responseErrors
      }
    });
  }

  if (Object.keys(combinedData).length === 0) {
    throw new Error(NO_DATA_OR_ERRORS_ERROR);
  }
}

function createMultipartResponseAsyncInterator(response, responseContentType) {
  var _response$body;

  var boundaryHeader = (responseContentType !== null && responseContentType !== void 0 ? responseContentType : '').match(BOUNDARY_HEADER_REGEX);
  var boundary = "--".concat(boundaryHeader ? boundaryHeader[1] : '-');

  if (!((_response$body = response.body) !== null && _response$body !== void 0 && _response$body.getReader) && !response.body[Symbol.asyncIterator]) {
    throw new Error('API multipart response did not return an iterable body', {
      cause: response
    });
  }

  var streamBodyIterator = getStreamBodyIterator(response);
  var combinedData = {};
  var responseExtensions;
  return _defineProperty({}, Symbol.asyncIterator, function () {
    return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var streamHasNext, _iteratorAbruptCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _responseData$find$ex, _responseData$find, chunkBodies, responseData, responseErrors, cause;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              streamHasNext = true;
              _iteratorAbruptCompletion3 = false;
              _didIteratorError3 = false;
              _context6.prev = 4;
              _iterator3 = _asyncIterator(readStreamChunk(streamBodyIterator, boundary));

            case 6:
              _context6.next = 8;
              return _awaitAsyncGenerator(_iterator3.next());

            case 8:
              if (!(_iteratorAbruptCompletion3 = !(_step3 = _context6.sent).done)) {
                _context6.next = 21;
                break;
              }

              chunkBodies = _step3.value;
              responseData = getResponseDataFromChunkBodies(chunkBodies);
              responseExtensions = (_responseData$find$ex = (_responseData$find = responseData.find(function (datum) {
                return datum.extensions;
              })) === null || _responseData$find === void 0 ? void 0 : _responseData$find.extensions) !== null && _responseData$find$ex !== void 0 ? _responseData$find$ex : responseExtensions;
              responseErrors = combineErrors(responseData);
              combinedData = buildCombinedDataObject([combinedData].concat(_toConsumableArray(responseData.map(function (_ref11) {
                var data = _ref11.data;
                return data;
              }))));
              streamHasNext = responseData.slice(-1)[0].hasNext;
              validateResponseData(responseErrors, combinedData);
              _context6.next = 18;
              return _objectSpread(_objectSpread(_objectSpread({}, getKeyValueIfValid('data', combinedData)), getKeyValueIfValid('extensions', responseExtensions)), {}, {
                hasNext: streamHasNext
              });

            case 18:
              _iteratorAbruptCompletion3 = false;
              _context6.next = 6;
              break;

            case 21:
              _context6.next = 27;
              break;

            case 23:
              _context6.prev = 23;
              _context6.t0 = _context6["catch"](4);
              _didIteratorError3 = true;
              _iteratorError3 = _context6.t0;

            case 27:
              _context6.prev = 27;
              _context6.prev = 28;

              if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
                _context6.next = 32;
                break;
              }

              _context6.next = 32;
              return _awaitAsyncGenerator(_iterator3.return());

            case 32:
              _context6.prev = 32;

              if (!_didIteratorError3) {
                _context6.next = 35;
                break;
              }

              throw _iteratorError3;

            case 35:
              return _context6.finish(32);

            case 36:
              return _context6.finish(27);

            case 37:
              if (!streamHasNext) {
                _context6.next = 39;
                break;
              }

              throw new Error("Response stream terminated unexpectedly");

            case 39:
              _context6.next = 46;
              break;

            case 41:
              _context6.prev = 41;
              _context6.t1 = _context6["catch"](0);
              cause = getErrorCause(_context6.t1);
              _context6.next = 46;
              return _objectSpread(_objectSpread(_objectSpread({}, getKeyValueIfValid('data', combinedData)), getKeyValueIfValid('extensions', responseExtensions)), {}, {
                errors: _objectSpread(_objectSpread({
                  message: formatErrorMessage(getErrorMessage(_context6.t1)),
                  networkStatusCode: response.status
                }, getKeyValueIfValid('graphQLErrors', cause === null || cause === void 0 ? void 0 : cause.graphQLErrors)), {}, {
                  response: response
                }),
                hasNext: false
              });

            case 46:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 41], [4, 23, 27, 37], [28,, 32, 36]]);
    }))();
  });
}

function generateRequestStream(fetchFn) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var response,
        statusText,
        responseContentType,
        _args8 = arguments;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (DEFER_OPERATION_REGEX.test(_args8.length <= 0 ? undefined : _args8[0])) {
              _context8.next = 2;
              break;
            }

            throw new Error(formatErrorMessage('This operation does not result in a streamable response - use request() instead.'));

          case 2:
            _context8.prev = 2;
            _context8.next = 5;
            return fetchFn.apply(void 0, _args8);

          case 5:
            response = _context8.sent;
            statusText = response.statusText;

            if (response.ok) {
              _context8.next = 9;
              break;
            }

            throw new Error(statusText, {
              cause: response
            });

          case 9:
            responseContentType = response.headers.get('content-type') || '';
            _context8.t0 = true;
            _context8.next = _context8.t0 === responseContentType.includes(CONTENT_TYPES.json) ? 13 : _context8.t0 === responseContentType.includes(CONTENT_TYPES.multipart) ? 14 : 15;
            break;

          case 13:
            return _context8.abrupt("return", createJsonResponseAsyncIterator(response));

          case 14:
            return _context8.abrupt("return", createMultipartResponseAsyncInterator(response, responseContentType));

          case 15:
            throw new Error("".concat(UNEXPECTED_CONTENT_TYPE_ERROR, " ").concat(responseContentType), {
              cause: response
            });

          case 16:
            _context8.next = 21;
            break;

          case 18:
            _context8.prev = 18;
            _context8.t1 = _context8["catch"](2);
            return _context8.abrupt("return", _defineProperty({}, Symbol.asyncIterator, function () {
              return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                var response;
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        response = getErrorCause(_context8.t1);
                        _context7.next = 3;
                        return {
                          errors: _objectSpread(_objectSpread({
                            message: formatErrorMessage(getErrorMessage(_context8.t1))
                          }, getKeyValueIfValid('networkStatusCode', response === null || response === void 0 ? void 0 : response.status)), getKeyValueIfValid('response', response)),
                          hasNext: false
                        };

                      case 3:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              }))();
            }));

          case 21:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[2, 18]]);
  }));
}

export { createGraphQLClient, generateClientLogger };